export const FIELD_ICONS = {
  email: 'email',
  password: 'lock',
};
